'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = 'M304 16l-33.6 19.4-169.1 97.9C38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7L476.6 241.6 496 208c-40 3.1-43 3.3-59.9 4.6 1.4-4.1 22.1-62 62-173.7L512 0c-9 3.2-68.9 24.6-179.6 64.1l-33 11.8c2.5-32.5 3.2-41.2 4.6-59.9zM117.3 161.1l150.1-86.9-3.7 48.5c13.9-5 79-28.2 195.4-69.8-41.6 116.4-64.8 181.6-69.8 195.4l48.5-3.7-86.9 150.1c-30.6 52.8-87 85.3-148 85.3-94.4 0-171-76.5-171-171 0-61 32.5-117.4 85.3-148zm108.6 55.5L208 180.8c-11.3 22.6-24.5 48.9-39.6 79-33.5 4.8-63 9-88.4 12.7 18.6 17.9 39.9 38.4 64 61.5-5.7 32.7-10.7 61.7-15.1 86.8 22.5-11.7 48.9-25.3 79.1-41 30.2 15.7 56.6 29.3 79.1 41-4.4-25.1-9.4-54.1-15.1-86.8 24.1-23.1 45.4-43.6 64-61.5-25.5-3.6-54.9-7.9-88.4-12.7l-21.7-43.3zM243 291.5l23.5 3.4c-11.9 11.4-21.5 20.7-29 27.8 1.8 10.1 4.1 23.4 7 40-15.7-8.1-27.9-14.4-36.5-18.9-8.6 4.5-20.8 10.8-36.5 18.9 2.9-16.6 5.2-29.9 7-40-7.4-7.2-17.1-16.4-29-27.8 16.8-2.4 30.2-4.3 40.1-5.7 4.4-8.8 10.6-21.1 18.4-36.8 7.9 15.7 14 28 18.4 36.8l16.6 2.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;